import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	OBAC: `${RouteNames.OBJECTS}-obac`,
	RBAC: `${RouteNames.OBJECTS}-rbac`,
});
